import axios from '../../../axios';
import ICandidateSubmissionSearchFilterVM from '../types/ICandidateSubmissionSearchFilterVM';
import ISubmissionAssign from '../types/ISubmissionAssign';
import NewSubmissionDownloadPayLoad from '../types/NewSubmissionDownloadPayLoad';

const url = '/candidatesearch/api/';

export const getSubmissions = (payload: ICandidateSubmissionSearchFilterVM) =>
  axios.post(`${url}submission/search`, payload);
export const downloadSubmissionsNew = (type: string, payload: NewSubmissionDownloadPayLoad) =>
  axios.post(`${url}submission/download/${type}`, payload);

export const pushSubmissionToDataAnalytics = (emailIdandCandidateId: {
  submissionId: string;
  emailId: string;
}) =>
  axios.post(`${url}submission/grc/submit`, null, {
    params: {
      submissionId: emailIdandCandidateId.submissionId,
      emailId: emailIdandCandidateId.emailId,
    },
  });

export const updateSubmissionAssignment = (payload: ISubmissionAssign) =>
  axios.post(`${url}submission/assignment`, payload);

export const getPendingSubmissionCount = () => axios.get(`${url}submission/pending-count`);
